export async function apiFetch(
  endpoint: string,
  requestOptions?: object
): Promise<void> {
  const originHost = 'top10homeservices.com';
  let url;
  if (process.env.NODE_ENV === 'production') {
    url = `https://service.${originHost}${endpoint}`;
  } else {
    url = `http://localhost:6004${endpoint}`;
  }
  const payload = JSON.stringify(requestOptions);
  if (typeof navigator.sendBeacon === 'function') {
    navigator.sendBeacon(url, payload);
  } else {
    await fetch(url, requestOptions);
  }
}
